import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavIconProspector = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1288_20732)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0.426621 12.8916L1.51698 11.8012C1.5662 11.752 1.63291 11.7246 1.7029 11.7246H1.88117C1.57932 11.3386 1.39996 10.853 1.39996 10.3248C1.39996 9.06818 2.41815 8.05 3.67474 8.05C4.93134 8.05 5.94952 9.06818 5.94952 10.3248C5.94952 11.5814 4.93134 12.5996 3.67474 12.5996C3.14651 12.5996 2.66093 12.4202 2.27488 12.1184V12.2966C2.27488 12.3666 2.24754 12.4333 2.19832 12.4825L1.10796 13.5729C1.00516 13.6757 0.838924 13.6757 0.737215 13.5729L0.427714 13.2634C0.324912 13.1606 0.324912 12.9944 0.426621 12.8916ZM3.67474 11.7246C4.44795 11.7246 5.0746 11.0991 5.0746 10.3248C5.0746 9.55157 4.44904 8.92491 3.67474 8.92491C2.90154 8.92491 2.27488 9.55048 2.27488 10.3248C2.27488 11.098 2.90044 11.7246 3.67474 11.7246Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.53477 8.75C9.59219 8.19219 9.625 7.60703 9.625 7C9.625 6.39297 9.59492 5.80781 9.53477 5.25H4.46797C4.41055 5.80781 4.37773 6.39297 4.37773 7C4.37773 7.0371 4.37785 7.07412 4.37807 7.11106C5.2962 7.34826 6.06825 7.94873 6.53176 8.75H9.53477Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.82082 13.1199C6.54412 12.4787 7 11.5426 7 10.5C7 10.1979 6.96172 9.90467 6.88973 9.625H9.41445C9.24766 10.6203 8.99062 11.5008 8.67617 12.2117C8.38906 12.857 8.06914 13.3246 7.76016 13.6199C7.45391 13.9125 7.19961 14 7 14C6.80039 14 6.54609 13.9125 6.23984 13.6227C6.10105 13.49 5.96006 13.3226 5.82082 13.1199Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.468238 8.75H0.221484C0.0765625 8.18945 0 7.6043 0 7C0 6.3957 0.0765625 5.81055 0.221484 5.25H3.5875C3.53008 5.81328 3.5 6.39844 3.5 7C2.20451 7 1.0734 7.70385 0.468238 8.75Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.7785 5.25H10.4125C10.4699 5.81328 10.5 6.39844 10.5 7C10.5 7.60156 10.4699 8.18672 10.4125 8.75H13.7785C13.9234 8.18945 14 7.6043 14 7C14 6.3957 13.9234 5.81055 13.7785 5.25Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.3004 4.375H13.4887C12.6711 2.34883 10.9293 0.795703 8.78828 0.229687C9.48555 1.16484 10.027 2.62773 10.3004 4.375Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.32383 1.78555C5.00938 2.49922 4.75234 3.37969 4.58555 4.375H9.41445C9.24766 3.37695 8.99336 2.49648 8.67617 1.78555C8.38906 1.14023 8.06914 0.672656 7.76016 0.377344C7.45391 0.0875 7.19961 0 7 0C6.80039 0 6.54609 0.0875 6.23984 0.377344C5.93086 0.672656 5.61094 1.14023 5.32383 1.78555Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.508594 4.375H3.69961C3.97305 2.62773 4.51445 1.16484 5.21172 0.229687C3.06797 0.795703 1.32891 2.34883 0.508594 4.375Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.79102 13.7703C10.932 13.2043 12.6711 11.6512 13.4914 9.625H10.3031C10.027 11.3723 9.48828 12.8352 8.79102 13.7703Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1288_20732",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "currentColor"
		})
	}) })]
});
export default SvgNavIconProspector;
